import muster from '@dbk-legacy/muster';
import { getValues } from '@dbk-legacy/muster/utils';
import { variable } from '@dbk-legacy/muster/helpers';
import isValidJsonString from '../utils/is-valid-json-string';
import { Base64 } from 'js-base64';
import { VASCO_API_RESPONSE, VASCO_API_ERROR_CODES, CHANNEL_TYPES, VASCO_ERROR_MESSAGES, ROUTES, PAPERLESS_OPT_IN_STATUS } from '../constants';
import Guid from '../utils/guid';

export default () => {
  return muster()
    .path('hrmw.getBpData', {
      call: async ({ req }, { get, set, call }) => {
        await set('hrmw.showSpinner', true);
        await set('hrmw.isValidData', true);
        const [messages] = await getValues(get('i18n.messages'));
        const [authUserId] = await getValues(get('auth.userId'));
        const userId = authUserId;
        const base64UserId = Base64.encode(userId);
        const guidStr = Guid();
        const [oReturn] = await getValues(get(`roster.data.hrmw.getBpData["${base64UserId}"]["${guidStr}"]`));

        isValidJsonString(oReturn).then(async (data) => {
          if (data) {
            await set('hrmw.bpRoleData', data.businessPartners);
            await set('hrmw.showSpinner', false);
          }
          else {
            await set('hrmw.isValidData', false);
            await set('hrmw.showSpinner', false);
            await set('hrmw.bpError', messages['app.manageContactDetails.error.tryagain']);
          }
        }).catch(async () => {
          await set('hrmw.isValidData', false);
          await set('hrmw.showSpinner', false);
          await set('hrmw.bpError', messages['app.manageContactDetails.error.tryagain']);
        })
      }
    })

    .path('hrmw.signContact', {
      call: async ({ req }, { get, set, call }) => {
        const oneTimePassword = req.args[0];
        const deviceCode = 'BROWSER';
        const otp = Base64.encode(oneTimePassword);
        const [bpId] = await getValues(get('hrmw.bpIdSelected'));
        const base64BpId = Base64.encode(bpId);
        const channel = CHANNEL_TYPES.WEB;
        const inputParam = `${base64BpId}#@#${deviceCode}#@#${otp}#@#${channel}`;
        const guidStr = Guid();
        const [oReturn] = await getValues(get(`roster.data.hrmw.signContact["${inputParam}"]["${guidStr}"]`));

        const oResult = JSON.parse(oReturn);
        await set('hrmw.isRowDeleted', false);
        await set('hrmw.isRowAdded', false);
        await set('hrmw.isManageContactDetailsMcd', false);
        const isEdocumentFlow =await getValues(get('paperless.isEdocumentFlow'));
        const path = isEdocumentFlow[0] ? ROUTES.PAPERLESS.PAPERLESS_SETTINGS_ROUTE : ROUTES.PROFILE.USER_BP_LIST_ROUTE ;
        call('ui.history.push', { pathname: path});
        if (oReturn.$type && oReturn.$type.toLowerCase() == VASCO_API_RESPONSE.error) {
          await set('vascoauthentication.vascoAuthorised', { type: 'error', errorMsg: oReturn.errorMsg || oReturn.value.message });
          return;
        }
        if (oResult.retCode === VASCO_API_ERROR_CODES.invalidSession) {
          await set('vascoauthentication.vascoAuthorised', false);
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.statusCode', oResult.retCode);
          return;
        }

        if (oResult.retCode === VASCO_API_ERROR_CODES.SUCCESS) {
          // Verify OTP check for E-Credentials: Password Reset
          await set('vascoauthentication.vascoAuthorised', true);
          await set('hrmw.otpVerified', true)
          // const [vascoPageName] = await getValues(get('ui.state.rsaPageName'));
          //  if (regionCode === "CH") {
          await set('vascoauthentication.otpStatus', true);
          await call('vascoauthentication.hideVasco');
          //  await set('auth.authHeader', oResult.jwt);
          //await set('auth.dashboardAuthorised', true);

          //  WMCE-16181 - commenting after submit tnc popup is coming for both mcd n paperless flow.
          // if (vascoPageName) {
          //   call('ui.history.replace', { pathname: vascoPageName });
          // }

          //  else {
          await set('auth.authorised', true);
          //    await set('auth.authHeader', oResult.jwt);
          //    await set('auth.dashboardAuthorised', true);
          //    await call('auth.getDashboardContent');
          await set('vascoauthentication.otpStatus', true);
          //    call('ui.history.push', { pathname: vascoPageName });
          await call('vascoauthentication.hideVasco');
          //  }
        }

        else if (oResult.retCode === VASCO_API_ERROR_CODES.otpIncorrect || oResult.retCode === VASCO_API_ERROR_CODES.otpReplay) {
          await set('vascoauthentication.vascoAuthorised', false);
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.statusCode', oResult.retCode);
        }
        else if (oResult.retCode === VASCO_API_ERROR_CODES.userLocked || (oResult.retCode === 0 && oResult.errorMsg === VASCO_ERROR_MESSAGES.otpVerificationErrorString)) {
          await set('vascoauthentication.vascoAuthorised', false);
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.statusCode', oResult.retCode);
        }
        else {
          await set('vascoauthentication.vascoAuthorised', false);
          await set('vascoauthentication.otpStatus', false);
          await set('vascoauthentication.statusCode', oResult.retCode);
        }

      }
    })

    .path('hrmw.contactDetailsOtp', {
      call: async ({ req }, { get, set, call }) => {
        await set('hrmw.isManageContactDetailsMcd', true);
        await set('vascoauthentication.vascoVisible', true);
        await set('hrmw.isManageContactDetails', true);
        await set('hrmw.saveContactDetailsStatus', '');
      }
    })

    .path('hrmw.getContactDetailsListData', {
      call: async ({ req }, { get, set, call }) => {
        await set('hrmw.showSpinner', true);
        await set('hrmw.isValidData', true);
        const [messages] = await getValues(get('i18n.messages'));
        const [authUserId] = await getValues(get('auth.userId'));
        const userId = authUserId;
        const base64UserId = Base64.encode(userId);
        const [bpId] = await getValues(get('hrmw.bpIdSelected'));
        const base64BpId = Base64.encode(bpId);
        const inputParam = `${base64UserId}#@#${base64BpId}`;
        const guidStr = Guid();
        const [oReturn] = await getValues(get(`roster.data.hrmw.getContactDetailsListData["${inputParam}"]["${guidStr}"]`));

        isValidJsonString(oReturn).then(async (data) => {
          if (data) {
            if(Array.isArray(data.contacts)) {
              data.contacts.forEach(function (row) {
                row.isUpdated = false;
                row.isNewlyAdded = false;
                row.isDeleted = false;
                row.isEalert = false;
              });
            }
            await set('hrmw.contactDetailsListData', data.contacts);
            await set('hrmw.contactDetailsPersonData', data.person);
            await set('hrmw.contactDetailsStatus', data.status);
          }
          else {
            await set('hrmw.contactDetailsListError', messages['app.manageContactDetails.error.tryagain']);
          }
        }).catch(async () => {
          await set('hrmw.contactDetailsListError', messages['app.manageContactDetails.error.tryagain']);
        })
        set('hrmw.showSpinner', false);
      }
    })

    // setting selected BP Id
    .path('hrmw.setBpId', {
      call: async ({ req }, { get, set, call }) => {
        const bpId = req.args[0];
        if (bpId) {
          await set('hrmw.bpIdSelected', bpId);
        } else {
          await set('hrmw.bpSetError', messages['app.manageContactDetails.error.tryagain']);
        }
      }
    })

    .path('hrmw.saveForm', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        await set('hrmw.showSpinner', true);
        await set('hrmw.isValidData', true);
        const bpId = await getValues(get('hrmw.bpIdSelected'));
        const base64BpId = Base64.encode(bpId);
        const [authUserId] = await getValues(get('auth.userId'));
        const userId = authUserId;
        const base64UserId = Base64.encode(userId);
        let reqParams = req.args[0];
        const strigifiedReqParams = JSON.stringify(reqParams);
        reqParams = Base64.encode(strigifiedReqParams);
        const inputParam = `${base64UserId}#@#${base64BpId}#@#${reqParams}`;
        const [oReturn] = await getValues(get(`roster.data.hrmw.saveForm["${inputParam}"]`));

        isValidJsonString(oReturn).then(async (data) => {
          if (data) {
            await set('hrmw.saveFormStatus', data);
          }
          else {
            await set('hrmw.isValidData', false);
            await set('hrmw.contactDetailsListError', messages['app.manageContactDetails.error.tryagain']);
          }
        }).catch(async () => {
          await set('hrmw.isValidData', false);
          await set('hrmw.contactDetailsListError', messages['app.manageContactDetails.error.tryagain']);
        })
        await set('hrmw.showSpinner', false);
      }
    })


    .path('hrmw.resetFormStatus', {
      call: async ({ req }, { get, set, call }) => {
        await set('hrmw.saveFormStatus', '');
        await set('hrmw.latestContactDetails', '');
        await set('hrmw.actualDataToBeSend', '');
        await set('hrmw.amendContactDetail', '');
        await set('hrmw.newContactDetails', '');
        await set('hrmw.deletedContact', '');
        await set('hrmw.contactDetailsListData', '');
        await set('hrmw.saveContactDetailsStatus', '');
        await set('hrmw.otpVerified', false);
        await set('hrmw.appliedFilters','');
        await set('hrmw.filterCount', 0);
      }
    })

    //setting contact details to be amend and update after amendment
    .path('hrmw.setAmendContactDetail', {
      call: async ({ req }, { get, set, call }) => {
        let contactRow = req.args[0];
        await set('hrmw.amendContactDetail', contactRow);
      }
    })

    .path('hrmw.saveFilters', {
      call: async ({ req }, { get, set, call }) => {
        let appliedFilters = req.args[0];
        await set('hrmw.appliedFilters', appliedFilters);
        if( appliedFilters.filterCount ) {
          await set('hrmw.filterCount', appliedFilters.filterCount);
        } else {
          await set('hrmw.filterCount', 0);
        }
      }
    })

    .path('hrmw.setDeletedContactList', {
      call: async ({ req }, { get, set, call }) => {
        let setDeletedContact = req.args[0];
        await set('hrmw.deletedContact', setDeletedContact);
      }
    })

    .path('hrmw.setUpdatedContactDetails', {
      call: async ({ req }, { get, set, call }) => {
        let latestContactDetails = req.args[0];
        await set('hrmw.latestContactDetails', latestContactDetails);
      }
    })

    .path('hrmw.dataToBeSend', {
      call: async ({ req }, { get, set, call }) => {
        let contactDetails = req.args[0];
        await set('hrmw.actualDataToBeSend', contactDetails);
      }
    })

    // saving newly added contact details
    .path('hrmw.setNewContactDetails', {
      call: async ({ req }, { get, set, call }) => {
        let contactDetails = req.args[0];
        await set('hrmw.newContactDetails', contactDetails);
      }
    })

    .path('hrmw.setDataUpdate', {
      call: async ({ req }, { get, set, call }) => {
        const dataUpdate = req.args[0];
        await set('hrmw.isDataUpdated', dataUpdate);
      }
    })

    .path('hrmw.setfromPaperless', {
      call: async ({ req }, { get, set, call }) => {
        const fromPaperless = req.args[0];
        await set('hrmw.fromPaperless', fromPaperless);
      }
    })

    .path('hrmw.saveContactDetails', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        await set('hrmw.showSpinner', true);
        await set('hrmw.otpVerified', false);
        await set('hrmw.isManageContactDetails', false);
        const [acceptAndProceed] = await getValues(get('paperless.acceptAndProceed'));
        const paperlessStatus = acceptAndProceed ?  PAPERLESS_OPT_IN_STATUS.YES : PAPERLESS_OPT_IN_STATUS.NO;
        const basePaperlessStatus = Base64.encode(paperlessStatus);
        const [bpId] = await getValues(get('hrmw.bpIdSelected'));
        const base64BpId = Base64.encode(bpId);
        const [authUserId] = await getValues(get('auth.userId'));
        const userId = authUserId;
        const base64UserId = Base64.encode(userId);
        let reqParams = req.args[0];
        const strigifiedReqParams = JSON.stringify(reqParams);
        reqParams = Base64.encode(strigifiedReqParams);
        const inputParam = `${base64UserId}#@#${base64BpId}#@#${reqParams}#@#${basePaperlessStatus}`;
        const [oReturn] = await getValues(get(`roster.data.hrmw.saveContactDetails["${inputParam}"]`));
        isValidJsonString(oReturn).then(async (data) => {
          if (data && data.contacts) {
            await set('hrmw.saveContactDetailsStatus', data);
          }
          else {
            await set('hrmw.saveContactDetailsError', true);
            await set('hrmw.saveContactDetailsErrorMessage', data.message);
          }
        }).catch(async () => {
          await set('hrmw.saveContactDetailsError', true);
          await set('hrmw.saveContactDetailsErrorMessage', messages['app.manageContactDetails.error.tryagain']);
        })
        await set('hrmw.showSpinner', false);
      }
    })

    .path('hrmw.showSpinner', variable(''))
    .path('hrmw.isValidData', variable(true))
    .path('hrmw.bpRoleData', variable(''))
    .path('hrmw.bpError', variable(""))
    .path('hrmw.contactDetailsListData', variable(''))
    .path('hrmw.contactDetailsPersonData', variable(''))
    .path('hrmw.contactDetailsListError', variable(""))
    .path('hrmw.bpIdSelected', variable(""))
    .path('hrmw.bpSetError', variable(""))
    .path('hrmw.saveFormStatus', variable(""))
    .path('hrmw.amendContactDetail', variable(""))
    .path('hrmw.appliedFilters', variable(""))
    .path('hrmw.saveContactDetailsStatus', variable(""))
    .path('hrmw.deletedContact', variable(""))
    .path('hrmw.latestContactDetails', variable(""))
    .path('hrmw.actualDataToBeSend', variable(""))
    .path('hrmw.saveContactDetailsError', variable(false))
    .path('hrmw.saveContactDetailsErrorMessage', variable(""))
    .path('hrmw.newContactDetails', variable(""))
    .path('hrmw.otpVerified', variable(false))
    .path('hrmw.isManageContactDetailsMcd', variable(false))
    .path('hrmw.isManageContactDetails', variable(false))
    .path('hrmw.contactDetailsStatus', variable(''))
    .path('hrmw.isRowDeleted', variable(false))
    .path('hrmw.isRowAdded', variable(false))
    .path('hrmw.isDataUpdated', variable(false))
    .path('hrmw.toggledContactDetail', variable(""))
    .path('hrmw.filterCount', variable(0))
    .path('hrmw.isUserBpListPage', variable(false))
    .path('hrmw.isAddContactDetailsFlow', variable(false))
    .path('hrmw.isMCDPage', variable(false))
   
    .path('hrmw.fromPaperless', variable(false));
}